/**
 * Created by Ning Jiang on 4/3/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {Elastic, TimelineLite, TweenLite} from "gsap";
import {WildNudgeGameConfig} from "../../WildNudgeGameConfig";

export class WildNudgeNudgeStackedSymbolWPView extends BaseView {

    private readonly _style = {
        fontName : "NumbersHotNudge",
        fontSize : 32,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    private _layer:ScalableLayer;
    private _multiplierCounter:PIXI.BitmapText;
    private _timeline:TimelineLite;

    constructor() {
        super();

        this._layer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.POP_NUMBERS.name);
    }

    protected initAnimations():void {
        this._multiplierCounter = new PIXI.BitmapText("0", this._style);
        this._multiplierCounter.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.3);
        this._multiplierCounter.visible = false;
        this._layer.addChild(this._multiplierCounter);
    }

    public showMultiplier(text:string, isEnding:boolean):void {
        this.kill();

        this._timeline = new TimelineLite({
            onStart : () => {
                this._multiplierCounter.text = text;
                this._multiplierCounter.updateTransform();
                this._multiplierCounter.pivot.set(this._multiplierCounter.textWidth * 0.5, this._multiplierCounter.textHeight * 0.5);
                this._multiplierCounter.alpha = 1;
                this._multiplierCounter.visible = true;
            }
        });
        this._timeline.add(TweenLite.fromTo(this._multiplierCounter.scale, 0.3,
            {x : 1, y : 1},
            {
                x : 1.3,
                y : 1.3,
                ease : Elastic.easeOut.config(2, 1)
            }));
        this._timeline.add(TweenLite.to(this._multiplierCounter, 0.3, {
            alpha : 0, onComplete : () => {
                this._multiplierCounter.visible = false;
            }
        }));
        this._timeline.play();
    }

    public abortMultiplierAnimations():void {
        this.kill();
        this._multiplierCounter.visible = false;
    }

    private kill():void {
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.paused();
            this._timeline.kill();
        }
    }
}